/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { HiCheck, HiPlus } from 'react-icons/hi';
import { FaList } from 'react-icons/fa';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { addYears, endOfDay, format, parseISO } from 'date-fns';

import * as Yup from 'yup';
import Swal from 'sweetalert2';

import getValidationErros from '~/utils/getValidationsErrors';

import { Cards, Container, Filter, Modal } from './styles';

import imgDefault from '~/assets/default/qrcode.png';
import Input from '~/components/Input';
import Select, { IOption } from '~/components/Select';
import InputDate from '~/components/InputDate';
import api from '~/services/api';
import InputMask from '~/components/InputMask';
import FiltersLists from '~/components/FiltersLists';
import Toast from '~/utils/toast';
import { KrClose, KrEdit } from '~/components/KoroIcons';
import Loading from '~/components/Loading';
import { formatPrice } from '~/utils/format';
import InfiniteScroll from '~/components/InfiniteScroll';
import ExportCsv from '~/components/ExportCsv';
import formatDate from '~/utils/formatDate';
import InputCheckbox from '~/components/InputCheckbox';

interface IVoucher {
  uniqueCode: boolean;
  eventStatusId: number;
  id: number;
  code: string;
  event: string;
  start: string;
  dueDate: string;
  status: string;
  maxUse: number;
  used: number;
  discountType: string;
  discountValue: number;
}

interface IVoucherDate {
  unique_code_use: boolean;
  id: number;
  event_status_id: number;
  event_id: number;
  event_name: string;
  code: string;
  due_date: string;
  quantity: number;
  used_quantity?: number;
  price?: number;
  percent?: number;
  status: string;
  created_at: string;
}

interface IVoucherResponse {
  data: IVoucherDate[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

interface IFormData {
  code: string;
  event: string;
  dueDate: string;
  maxUse: string;
  discountType: string;
  discountValue: string;
}

interface IEventData {
  end_date: string;
  id: number;
  name: string;
  search: string;
}

interface IStatus {
  id: number;
  name: string;
}

interface IEventType {
  id: number;
  name: string;
}

const Vouchers: React.FC = () => {
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [vouchers, setVouchers] = useState<IVoucher[]>([]);
  const formRef = useRef<FormHandles>(null);
  const [events, setEvents] = useState<IOption[]>([]);
  const [discountType, setDiscountType] = useState('percent');
  const [voucherSelected, setVoucherSelected] = useState({} as IVoucher);
  const [endDate, setEndDate] = useState(endOfDay(addYears(new Date(), 1)));
  const [categories, setCategories] = useState<IOption[]>([]);
  const [status, setStatus] = useState<IOption[]>([]);
  const [vouchersData] = useState<IOption[]>([
    {
      id: 'active',
      value: 'Ativo',
      selected: true,
    },
    {
      id: 'not-active',
      value: 'Inativo',
      selected: false,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [errorMaxUse, setErrorMaxUse] = useState(false);
  const [statusFilter, setStatusFilter] = useState('active');
  const [eventFilter, setEventFilter] = useState('');
  const [codeFilter, setCodeFilter] = useState('');
  const [checkCopies, setCheckCopies] = useState(false);
  const [discountValue, setDiscountValue] = useState('');
  const [maxUse, setMaxUse] = useState('');
  const [quantityCopies, setQuantityCopies] = useState('');
  const [eventNameModal, setEventNameModal] = useState('');
  const [exportData, setExportData] = useState<any[]>([]);
  const [debouncedSearch, setDebouncedSearch] = useState(eventNameModal);
  const [uniqueCodeVoucher, setUniqueCodeVoucher] = useState(false);

  // subir

  useEffect(() => {
    if (
      discountType !== 'percent' ||
      discountValue !== '100' ||
      maxUse !== '1'
    ) {
      setCheckCopies(false);
    }
  }, [discountType, discountValue, maxUse]);

  useEffect(() => {
    api.get<IStatus[]>('events-status').then((response) => {
      const data = response.data.map<IOption>((statusData) => ({
        id: statusData.id,
        value: statusData.name,
        selected: false,
      }));
      setStatus(data);
    });
  }, []);

  useEffect(() => {
    api
      .get<IEventType[]>('events-types', { params: { isOrganizer: true } })
      .then((response) => {
        const data = response.data.map<IOption>((modality) => ({
          id: modality.id,
          value: modality.name,
          selected: false,
        }));

        setCategories(data);
      });
  }, []);

  const handleLoadEvents = useCallback(async (search = '') => {
    try {
      const response = await api.get<IEventData[]>('events/organizer', {
        params: {
          status_ids: [1, 2, 3, 4, 5, 9],
          search: search.trim(),
        },
      });
      const data = response.data.map<IOption>((event) => ({
        id: event.id,
        value: event.name,
        end_date: event.end_date,
        selected: false,
      }));
      setEventNameModal(search);
      setEvents(data);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleSelectEvent = useCallback(
    (option) => {
      const selectedEvent = events.find((event) => event.id === option.id);
      setEndDate(new Date(selectedEvent?.end_date || ''));
    },
    [events]
  );

  const handleLoadVouchers = useCallback(
    async (
      pageData,
      statusData?: string,
      event?: string,
      voucherCode?: string
    ) => {
      setLoading(true);
      const response = await api
        .get<IVoucherResponse>('vouchers/organizers', {
          params: {
            page: pageData,
            status: statusData,
            event,
            code: voucherCode,
          },
        })
        .finally(() => {
          setLoading(false);
        });
      const data = response.data.data.map((voucher) => {
        return {
          id: voucher.id,
          code: voucher.code,
          uniqueCode: voucher.unique_code_use,
          event: voucher.event_name,
          eventStatusId: voucher.event_status_id,
          start: formatDate(parseISO(voucher.created_at), 'dd/MM/yyyy'),
          dueDate: formatDate(parseISO(voucher.due_date), 'dd/MM/yyyy'),
          status: voucher.status,
          maxUse: voucher.quantity,
          used: voucher.used_quantity || 0,
          discountType:
            voucher.price && parseInt(voucher.price.toString(), 10) > 0
              ? 'value'
              : 'percent',
          discountValue:
            voucher.price && parseInt(voucher.price.toString(), 10) > 0
              ? parseInt(voucher.price.toString(), 10)
              : voucher.percent || 0,
        };
      });

      setTotalPages(response.data.pages);

      if (pageData === 1) {
        setVouchers(data);
      } else {
        setVouchers((oldState) => [...oldState, ...data]);
      }
    },
    []
  );

  const handleChangeTextEvent = useCallback((text) => {
    setEventNameModal(text);
  }, []);

  useEffect(() => {
    handleLoadEvents(debouncedSearch);
  }, [debouncedSearch, handleLoadEvents]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(eventNameModal);
    }, 500);

    return () => clearTimeout(timer);
  }, [eventNameModal]);

  useEffect(() => {
    handleLoadVouchers(1, 'active');
  }, [handleLoadVouchers]);

  const handleLoad = useCallback(async () => {
    if (loadingMore) return;

    if (page < totalPages) {
      setLoadingMore(true);
      const nextPage = page + 1;

      await handleLoadVouchers(nextPage, statusFilter, eventFilter, codeFilter);
      setPage(nextPage);

      setLoadingMore(false);
    }
  }, [
    loadingMore,
    page,
    totalPages,
    handleLoadVouchers,
    statusFilter,
    eventFilter,
    codeFilter,
  ]);

  const handleEndDate = useCallback((e) => {
    setEndDate(e);
  }, []);

  const handleCloseAdd = useCallback(() => {
    setShow(false);
    setEventNameModal('');
    setCheckCopies(false);
  }, []);

  const handleExportCsv = async () => {
    return exportData;
  };

  const handleExportSwal = useCallback(() => {
    setTimeout(() => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `Gostaria de salvar o arquivo Cupons_gratuitos.csv?`,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then((e) => {
        if (e.isConfirmed) {
          const element = document.getElementById('export');
          element?.click();
        }
      });
    }, 1000);
  }, []);

  const handleTriggerExport = useCallback(
    (data: any[]) => {
      if ('showSaveFilePicker' in window) {
        const csvColumns = [
          { name: 'Nome do Evento', selector: 'eventName' },
          { name: 'Data Validade do Cupom', selector: 'dueDate' },
          { name: 'Codigo do cupom', selector: 'code' },
        ];
        const header = csvColumns.map((c) => c.name).join(',');
        const rows = data.map((row) =>
          csvColumns
            .map(
              (c) => `"${String(row[c.selector] ?? '').replace(/"/g, '""')}"`
            )
            .join(',')
        );
        const csvContent = [header, ...rows].join('\n');
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        });

        (window as any)
          .showSaveFilePicker({
            suggestedName: 'Cupons_gratuitos.csv',
            types: [
              { description: 'CSV files', accept: { 'text/csv': ['.csv'] } },
            ],
          })
          .then(async (handle: any) => {
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
          })
          .catch(() => {
            setExportData(data);
            const element = document.getElementById('export');
            element?.click();
          });
      } else {
        setExportData(data);
        handleExportSwal();
      }
    },
    [handleExportSwal]
  );

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      const responseAllVouchers = await api.get<IVoucherDate[]>(
        'vouchers/organizers'
      );

      const vouchersAll = responseAllVouchers.data.map((voucher) => {
        return {
          id: voucher.id,
          code: voucher.code,
          event: voucher.event_name,
          eventId: voucher.event_id,
          // event_statusId: voucher.event.status_id,
        };
      });

      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          code: Yup.string()
            .required('O code é obrigatório')
            .test(
              'isUnique',
              'Código já cadastrado para este evento',
              (value) => {
                const eventId = parseInt(
                  formRef.current?.getFieldValue('event'),
                  10
                );

                const vouchersEvent = vouchersAll.filter((voucher) => {
                  return voucher.eventId === eventId;
                });
                const exists = vouchersEvent.some(
                  (voucher) => voucher.code === value
                );

                return !exists;
              }
            ),
          event: Yup.string().required('O evento é obrigatório'),
          dueDate: Yup.string().required('A validade é obrigatória'),
          maxUse: Yup.string().required('O máximo de uso é obrigatório'),
          discountType: Yup.string().required('O tipo de desconto obrigatório'),
          discountValue: Yup.string().required('A cor é obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const formData = {
          event_id: data.event,
          code: data.code.trim(),
          unique_code_use: uniqueCodeVoucher,
          due_date: format(
            new Date(data.dueDate).setHours(20, 59, 0, 0),
            'yyyy-MM-dd'
          ),
          quantity: data.maxUse,
          price:
            data.discountType === 'value'
              ? parseFloat(
                  data.discountValue
                    .replace('R$', '')
                    .replaceAll('.', '')
                    .replace(',', '.')
                )
              : 0,
          percent: data.discountType === 'percent' ? data.discountValue : '0',
        };

        if (checkCopies) {
          Swal.fire({
            icon: 'warning',
            iconColor: '#ff6900',
            title: `Será gerado cupom com${
              maxUse === '1' ? ` ${quantityCopies} cópias e` : ''
            } ${
              discountType === 'percent'
                ? `${discountValue}%`
                : `${discountValue}`
            } de desconto. Deseja continuar?`,
            showCancelButton: true,
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim',
            confirmButtonColor: '#ff6900',
            cancelButtonColor: '#B34A00',
            reverseButtons: true,
          }).then(async (e) => {
            if (e.isConfirmed) {
              handleCloseAdd();

              if (checkCopies && Number(quantityCopies) > 0) {
                const eventName =
                  events.find((es) => String(es.id) === String(data.event))
                    ?.value || '';
                const newData = [];

                const qtd = Number(quantityCopies);
                for (let i = 0; i < qtd; i += 1) {
                  const suffix = Math.random()
                    .toString(36)
                    .substring(2, 7)
                    .toUpperCase();
                  const codeCopy = `${data.code}-${
                    i + 1 < 10
                      ? `00${i + 1}`
                      : i + 1 < 100
                      ? `0${i + 1}`
                      : i + 1
                  }-${suffix}`;

                  // eslint-disable-next-line no-await-in-loop
                  await api.post('vouchers/organizers', {
                    ...formData,
                    code: codeCopy,
                  });

                  newData.push({
                    eventName,
                    dueDate: format(
                      new Date(data.dueDate).setHours(20, 59, 0, 0),
                      'dd/MM/yyyy'
                    ),
                    code: codeCopy,
                  });
                }

                handleTriggerExport(newData);
              } else {
                await api.post('vouchers/organizers', formData);
                if (maxUse === '1') {
                  const eventName =
                    events.find((es) => String(es.id) === String(data.event))
                      ?.value || '';

                  const newData = [
                    {
                      eventName,
                      dueDate: format(
                        new Date(data.dueDate).setHours(20, 59, 0, 0),
                        'dd/MM/yyyy'
                      ),
                      code: data.code,
                    },
                  ];

                  handleTriggerExport(newData);
                }
              }

              handleLoadVouchers(1, statusFilter, eventFilter, codeFilter);

              setShow(false);
              setCheckCopies(false);
              Toast.fire({
                icon: 'success',
                iconColor: '#ff6900',
                title: 'Cupom criado com sucesso!',
              });
            }
          });
        } else {
          handleCloseAdd();

          await api.post('vouchers/organizers', formData);

          handleLoadVouchers(1, statusFilter, eventFilter, codeFilter);

          setShow(false);
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Credenciais inválidas!');
        }
      } finally {
        setUniqueCodeVoucher(false);
      }
    },
    [
      checkCopies,
      codeFilter,
      discountType,
      discountValue,
      eventFilter,
      events,
      handleCloseAdd,
      handleLoadVouchers,
      handleTriggerExport,
      maxUse,
      quantityCopies,
      statusFilter,
      uniqueCodeVoucher,
    ]
  );

  const handleChangeDiscountType = useCallback((option) => {
    setDiscountType(option.id);
  }, []);

  const handleClickEdit = useCallback(
    (voucher) => {
      const newEvents = events.map((event) => ({
        ...event,
        selected: event.value === voucher.event,
      }));
      const [day, month, year] = voucher.dueDate.split('/');
      setDiscountType(voucher.discountType);
      setEvents(newEvents);
      setEndDate(new Date(year, month - 1, day));
      setVoucherSelected(voucher);
      setShowUpdate(true);
      setUniqueCodeVoucher(voucher.uniqueCode);
    },
    [events]
  );

  const handleClose = useCallback(() => {
    const newEvents = events.map((event) => ({
      ...event,
      selected: false,
    }));
    setEvents(newEvents);
    setEndDate(new Date());
    setVoucherSelected({} as IVoucher);
    setShowUpdate(false);
    setErrorMaxUse(false);
    setUniqueCodeVoucher(false);
  }, [events]);

  const handleSubmitUpdate = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          code: Yup.string().required('O code é obrigatório'),
          event: Yup.string().required('O evento é obrigatório'),
          dueDate: Yup.string().required('A validade é obrigatória'),
          maxUse: Yup.string().required('O máximo de uso é obrigatório'),
          discountType: Yup.string().required('O tipo de desconto obrigatório'),
          discountValue: Yup.string().required('A cor é obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const formData = {
          event_id: data.event,
          code: data.code.trim(),
          unique_code_use: uniqueCodeVoucher,
          due_date: data.dueDate,
          quantity: data.maxUse,
          price:
            data.discountType === 'value'
              ? parseFloat(
                  data.discountValue
                    .replace('R$', '')
                    .replaceAll('.', '')
                    .replace(',', '.')
                )
              : 0,
          percent: data.discountType === 'percent' ? data.discountValue : 0,
        };

        const response = await api.put(
          `vouchers/organizers/${voucherSelected.id}`,
          formData
        );

        const newVouchers = vouchers.slice();

        const voucherIndex = newVouchers.findIndex(
          (voucher) => voucher.id === voucherSelected.id
        );

        if (voucherIndex >= 0) {
          newVouchers[voucherIndex].code = data.code;
          newVouchers[voucherIndex].start = format(
            parseISO(response.data.created_at),
            'dd/MM/yyyy'
          );
          newVouchers[voucherIndex].dueDate = format(
            new Date(data.dueDate),
            'dd/MM/yyyy'
          );
          newVouchers[voucherIndex].status = 'Ativo';
          newVouchers[voucherIndex].maxUse = parseInt(data.maxUse, 10);
          newVouchers[voucherIndex].discountType = data.discountType;
          newVouchers[voucherIndex].discountValue =
            formData.price || parseFloat(formData.percent.toString() || '0');
          newVouchers[voucherIndex].uniqueCode = uniqueCodeVoucher;
        }

        setVouchers(newVouchers);

        setShowUpdate(false);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Credenciais inválidas!');
        }
      }
    },
    [uniqueCodeVoucher, voucherSelected.id, vouchers]
  );

  const handleSubmitFilters = useCallback(
    (data) => {
      setStatusFilter(data.status);
      setEventFilter(data.event);
      setCodeFilter(data.codeVoucher);
      handleLoadVouchers(1, data.status, data.event, data.codeVoucher);
    },
    [handleLoadVouchers]
  );

  const handleRemoveVoucher = useCallback((voucherData: IVoucher) => {
    if (voucherData.status === 'Ativo') {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: 'Inativar cupom?',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (e) => {
        if (e.isConfirmed) {
          await api.delete(`vouchers/organizers/${voucherData.id}`);
          setVouchers((prevVouchers) =>
            prevVouchers.map((voucher) => {
              if (voucher.id === voucherData.id) {
                return {
                  ...voucher,
                  status: 'Inativo',
                };
              }
              return voucher;
            })
          );
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Cupom inativado com sucesso!',
          });
        }
      });
    } else {
      const [day, month, year] = voucherData.dueDate.split('/');
      const dueDate = new Date(+year, +month - 1, +day);
      if (dueDate > new Date()) {
        Swal.fire({
          icon: 'warning',
          iconColor: '#ff6900',
          title: 'Ativar cupom?',
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim',
          confirmButtonColor: '#ff6900',
          cancelButtonColor: '#B34A00',
          reverseButtons: true,
        }).then(async (e) => {
          if (e.isConfirmed) {
            await api.patch(`vouchers/organizers/${voucherData.id}`);
            setVouchers((prevVouchers) =>
              prevVouchers.map((voucher) => {
                if (voucher.id === voucherData.id) {
                  return {
                    ...voucher,
                    status: 'Ativo',
                  };
                }
                return voucher;
              })
            );
            Toast.fire({
              icon: 'success',
              iconColor: '#ff6900',
              title: 'Cupom ativado com sucesso!',
            });
          }
        });
      }
    }
  }, []);

  const handleValidateMaxUse = useCallback(
    (e) => {
      const { value } = e.target;
      if (value < voucherSelected.used) {
        setErrorMaxUse(true);
      } else {
        setErrorMaxUse(false);
      }
    },

    [voucherSelected.used]
  );

  return (
    <Container>
      <InfiniteScroll
        id="infinite-scroll"
        onInfiniteLoad={handleLoad}
        className="infinite-scroll py-3"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="zoom col-12 px-0">
              <div className="bg-white d-flex justify-content-between align-items-center p-4">
                <h1 className="mb-0">Cupons</h1>
                <button
                  type="button"
                  onClick={() => setShow(true)}
                  className="mb-0 h6 fw-normal text-white btn-new px-5 py-2"
                >
                  <HiPlus size={16} color="#fff" className="me-2" />
                  Novo Cupom
                </button>
              </div>
            </div>
            <Filter className="col-12 px-0 mt-3">
              <FiltersLists
                onSubmitFilters={handleSubmitFilters}
                status
                codeVoucher
                event
                categories={categories}
                statusOptions={status}
                statusVouchersOptions={vouchersData}
              />
            </Filter>

            <div className="zoom col-12 px-lg-0">
              {vouchers.map((voucher) => {
                const isEventLocked = [4, 6, 7, 8].includes(
                  voucher.eventStatusId
                );
                return (
                  <Cards
                    key={voucher.id}
                    className="d-flex bg-white justify-content-between align-items-center p-2 pe-3 mt-2"
                  >
                    <div>
                      <img src={imgDefault} alt="Corrida" className="default" />
                    </div>
                    <div className="w-15">
                      <h3 className="mb-1">Código do cupom</h3>
                      <p className="mb-0">{voucher.code}</p>
                    </div>
                    <div className="w-20">
                      <h3 className="mb-1">Evento</h3>
                      <p className="mb-0">{voucher.event}</p>
                    </div>

                    <div>
                      <h3 className="mb-1">Valor desconto</h3>
                      <p className="mb-0 text-center">
                        {voucher.discountType === 'percent'
                          ? `${parseFloat(voucher.discountValue.toString())}%`
                          : `${formatPrice(voucher.discountValue)}`}
                      </p>
                    </div>
                    <div>
                      <h3 className="mb-1">Início</h3>
                      <p className="mb-0">{voucher.start}</p>
                    </div>
                    <div>
                      <h3 className="mb-1">Validade</h3>
                      <p className="mb-0">{voucher.dueDate}</p>
                    </div>
                    <div>
                      <h3 className="mb-1">Status</h3>
                      <p className="mb-0">{voucher.status}</p>
                    </div>
                    <div>
                      <h3 className="mb-1">Uso máximo</h3>
                      <p className="mb-0">{voucher.maxUse}</p>
                    </div>
                    <div>
                      <h3 className="mb-1">Usados</h3>
                      <p className="mb-0">{voucher.used}</p>
                    </div>
                    <div className="d-flex align-items-center">
                      {false && (
                        <button
                          type="button"
                          className="me-3 border-0 rounded-circle bg-orange"
                        >
                          <FaList size={16} color="#fff" />
                        </button>
                      )}
                      <button
                        type="button"
                        disabled={
                          voucher.eventStatusId === 4 ||
                          voucher.eventStatusId === 6 ||
                          voucher.eventStatusId === 7 ||
                          voucher.eventStatusId === 8
                        }
                        onClick={() => handleClickEdit(voucher)}
                        className="me-3 border-0 rounded-circle bg-orange btn-edit"
                      >
                        <KrEdit size={16} color="#fff" />
                      </button>

                      <div
                        className={`${
                          isEventLocked ? 'not-allowed' : 'pointer'
                        } form-check form-switch`}
                        title={
                          isEventLocked
                            ? 'Evento encerrado, cancelado ou finalizado'
                            : undefined
                        }
                      >
                        <input
                          className="form-check-input opacity-100 pointer"
                          type="checkbox"
                          disabled={isEventLocked}
                          id={`flexSwitch-${voucher.id}`}
                          checked={voucher.status === 'Ativo'}
                          onChange={() => handleRemoveVoucher(voucher)}
                        />
                      </div>
                    </div>
                  </Cards>
                );
              })}
            </div>
          </div>
        </div>
      </InfiniteScroll>
      <Modal
        className="zoom modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleCloseAdd}
      >
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Adicionar Cupom</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleCloseAdd}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="container pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr className="mb-5" />

                <h4 className="h6 fw-normal">Evento</h4>
                <Select
                  name="event"
                  className="input height"
                  options={events}
                  onChangeText={handleChangeTextEvent}
                  onChange={handleSelectEvent}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Código do cupom</h4>
                <Input
                  placeholder="CUPOM20"
                  name="code"
                  type="text"
                  className="input height"
                />
              </div>
              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">
                  Permitir usar mesmo cupom mais de uma vez
                </h4>
                <InputCheckbox
                  type="radio"
                  name="unique_code_use_voucher"
                  className="check-payments mt-3 justify-content-start"
                  options={[
                    {
                      label: 'Sim',
                      value: 'sim',
                      selected: uniqueCodeVoucher,
                    },
                    {
                      label: 'Não',
                      value: 'nao',
                      selected: !uniqueCodeVoucher,
                    },
                  ]}
                  onChange={() => {
                    setUniqueCodeVoucher(!uniqueCodeVoucher);
                  }}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Validade</h4>
                <InputDate
                  className="height-date"
                  name="dueDate"
                  selected={endDate}
                  onChange={handleEndDate}
                  colorSvg="#5D5D5D"
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Máximo de uso</h4>
                <Input
                  placeholder="0"
                  name="maxUse"
                  type="number"
                  className="input height"
                  onChange={(e) => setMaxUse(e.target.value)}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Tipo de desconto</h4>
                <Select
                  name="discountType"
                  className="input height"
                  options={[
                    {
                      id: 'percent',
                      value: 'Percentual',
                      selected: discountType === 'percent',
                    },
                    {
                      id: 'value',
                      value: 'Valor',
                      selected: discountType === 'value',
                    },
                  ]}
                  onChange={handleChangeDiscountType}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Valor de desconto</h4>
                {discountType === 'percent' ? (
                  <Input
                    placeholder="0"
                    name="discountValue"
                    type="number"
                    className="input height"
                    onChange={(e) => setDiscountValue(e.target.value)}
                  />
                ) : (
                  <InputMask
                    kind="money"
                    placeholder="0"
                    name="discountValue"
                    className="input height"
                    onChange={(e) => setDiscountValue(e.target.value)}
                  />
                )}
              </div>

              <div
                className={`${
                  maxUse === '1' ? 'opacity-100' : 'opacity-25'
                } d-flex`}
              >
                <div className="col-lg-6 mt-3">
                  <h4 className="h6 fw-normal">Copiar cupom</h4>
                  <button
                    type="button"
                    disabled={maxUse !== '1'}
                    onClick={() => setCheckCopies(!checkCopies)}
                    className="d-flex align-items-center check border-0 bg-transparent my-3"
                  >
                    <span className={`${checkCopies ? 'checked' : ''} me-2`}>
                      {checkCopies && (
                        <HiCheck
                          size={16}
                          color="#fff"
                          className="check-icon"
                        />
                      )}
                    </span>
                    Gerar cópias
                  </button>
                </div>
                {checkCopies && (
                  <div className="col-lg-6 mt-3 ps-3">
                    <h4 className="h6 fw-normal">Quantidade de cópias</h4>

                    <Input
                      placeholder="0"
                      min={1}
                      max={100}
                      onChange={(e) => setQuantityCopies(e.target.value)}
                      name="quantityCopies"
                      type="number"
                      className="input height"
                    />
                    {parseInt(quantityCopies, 10) > 100 && (
                      <p className="text-danger text-center">
                        Máximo de 100 cópias
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 mt-5 py-4 px-5 d-flex justify-content-end">
            <button
              type="submit"
              disabled={parseInt(quantityCopies, 10) > 100}
              className="ms-0 btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Adicionar Cupom
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        className="zoom modal-filter"
        size="lg"
        centered
        show={showUpdate}
        onHide={handleClose}
      >
        <Form
          ref={formRef}
          onSubmit={handleSubmitUpdate}
          initialData={voucherSelected}
        >
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Editar Cupom</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="container pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr className="mb-5" />
                <h4 className="h6 fw-normal">Evento</h4>
                <Select
                  name="event"
                  disabled
                  className="input height"
                  options={events}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Código do cupom</h4>
                <Input
                  placeholder="CUPOM20"
                  disabled
                  name="code"
                  type="text"
                  className="input height"
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">
                  Permitir usar mesmo cupom mais de uma vez
                </h4>
                <InputCheckbox
                  type="radio"
                  name="unique_code_use_voucher"
                  className="check-payments mt-3 justify-content-start"
                  options={[
                    {
                      label: 'Sim',
                      value: 'sim',
                      selected: uniqueCodeVoucher,
                    },
                    {
                      label: 'Não',
                      value: 'nao',
                      selected: !uniqueCodeVoucher,
                    },
                  ]}
                  onChange={() => {
                    setUniqueCodeVoucher(!uniqueCodeVoucher);
                  }}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Validade</h4>
                <InputDate
                  className="height-date"
                  name="dueDate"
                  selected={endDate}
                  onChange={handleEndDate}
                />
              </div>

              <div className="col-lg-6 mt-3">
                <h4 className="h6 fw-normal">Máximo de uso</h4>
                <Input
                  placeholder="0"
                  name="maxUse"
                  type="number"
                  className="input height"
                  onChange={handleValidateMaxUse}
                />
                <span className="text-danger small">
                  {errorMaxUse && 'O valor não pode ser menor que usado'}
                </span>
              </div>

              <div
                className={`col-lg-6 mt-3 ${
                  voucherSelected.used > 0 ? 'pe-none' : ''
                }`}
              >
                <h4 className="h6 fw-normal">Tipo de desconto</h4>
                <Select
                  name="discountType"
                  className="input height"
                  options={[
                    {
                      id: 'percent',
                      value: 'Percentual',
                      selected: discountType === 'percent',
                    },
                    {
                      id: 'value',
                      value: 'Valor',
                      selected: discountType === 'value',
                    },
                  ]}
                  onChange={handleChangeDiscountType}
                />
              </div>

              <div
                className={`col-lg-6 mt-3 ${
                  voucherSelected.used > 0 ? 'pe-none' : ''
                }`}
              >
                <h4 className="h6 fw-normal">Valor de desconto</h4>
                {discountType === 'percent' ? (
                  <Input
                    placeholder="0"
                    name="discountValue"
                    type="number"
                    className="input height"
                  />
                ) : (
                  <InputMask
                    kind="money"
                    placeholder="0"
                    name="discountValue"
                    className="input height"
                    value={Number(voucherSelected.discountValue ?? 0)
                      .toFixed(2)
                      .replace('.', ',')}
                  />
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 mt-5 py-4 px-5 d-flex justify-content-end">
            <button
              type="submit"
              disabled={errorMaxUse}
              className="ms-0 btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Salvar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ExportCsv
        id="export"
        data={exportData}
        columns={[
          {
            name: 'Nome do Evento',
            selector: 'eventName',
          },
          {
            name: 'Data Validade do Cupom',
            selector: 'dueDate',
          },
          {
            name: 'Codigo do cupom',
            selector: 'code',
          },
        ]}
        onClick={handleExportCsv}
        fileName="Cupons_gratuitos"
        className="d-none"
      />
      <Loading active={loading} text="Carregando..." />
    </Container>
  );
};

export default Vouchers;
